export default __webpack_public_path__ + "static/wavy_bg-d31d5935e884bf15977d51ca58dbd17a.svg";